import React from "react"
import { Col, Modal } from "antd";
import AccountInputValue from "../../commons/components/accountInputValue"
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setUserDataEmail } from "../../store/actions/userLoginActions";

import Utils from "../../commons/utils/utils";
import Message from '../../commons/utils/message'
import MailIcon from "../../commons/icons/mailIcon";
import Loading from "../../commons/components/loading";

import Http from "../../commons/utils/Http";

export default props => {
    const [showSolicitEmail, setShowSolicitEmail] = useState(false);
    const [showValidateCode, setShowValidateCode] = useState(false);

    const [newEmail, setNewEmail] = useState("");
    const [receivedCode, setReceivedCode] = useState("");

    const [loading, setLoading] = useState(false);

    const [hasErrorEmail, setHasErrorEmail] = useState(false);
    const [hasErrorCode, setHasErrorCode] = useState(false);
    const [errorMsgEmail, setErrorMsgEmail] = useState(false);
    const [errorMsgCode, setErrorMsgCode] = useState(false);

    const dispatch = useDispatch();

    const solicitEmail = () => {

        function validateForm() {
            let valid = true;

            if (newEmail === "") {
                setHasErrorEmail(true);
                setErrorMsgEmail("Informe um e-mail");
                valid = false;
            } else if (!Utils.validateEmail(newEmail)) {
                setHasErrorEmail(true);
                setErrorMsgEmail("E-mail inválido");
                valid = false;
            }

            return valid;
        }

        function handleOk() {
            if (validateForm()) {
                setLoading(true);

                const body = { "user_id": props.user_id, "previous_email": props.email, "new_email": newEmail, "main_email": true }
                Http.put('/users/request-email-change', body, Http.headers)
                    .then(response => {
                        const responseData = response.data.response
                        if (!responseData.error) {
                            setShowSolicitEmail(false);
                            setShowValidateCode(true);
                            setLoading(false);
                        }
                    }).catch(err => {
                        setHasErrorEmail(true);
                        setErrorMsgEmail(err.response.data.response.message);
                        setLoading(false);
                    })
            }
        }

        function handleCancel() {
            setShowSolicitEmail(false);
            setHasErrorEmail(false);
        }

        function renderForm() {
            if (loading) {
                return (
                    <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
                        <Loading width={50} height={50} />
                    </div>
                )
            } else {
                return (
                    <>
                        <p className={"modal-content-describe"}>Alterar e-mail principal</p>
                        <AccountInputValue style={{ width: '100%' }} name={"new_email"} labelText={"E-mail principal"} value={newEmail}
                            onChange={(e) => { setNewEmail(e.target.value); setHasErrorEmail(false) }}
                            hasError={hasErrorEmail} error={errorMsgEmail} />
                    </>
                );
            }
        }

        return (
            <Modal
                visible={showSolicitEmail}
                title="E-mail principal"
                centered={true}
                onCancel={handleCancel}
                onOk={handleOk}
                footer={[
                    <a key="back" style={{ marginRight: 24 }} className={"account-link"}
                        onClick={handleCancel}>Cancelar
                    </a>,
                    <button key="submit" type="primary" className={"account-button account-button-primary"}
                        onClick={handleOk}>Prosseguir
                    </button>
                ]}
            >
                {renderForm()}
            </Modal>
        );
    }

    const validateCode = () => {

        function validateForm() {
            let valid = true;

            if (receivedCode === "") {
                setHasErrorCode(true);
                setErrorMsgCode("Informe um código");
                valid = false;
            }

            return valid;
        }

        function handleOk() {
            if (validateForm()) {
                setLoading(true);

                const bodyCheckCode = { "user_id": props.user_id, "code": receivedCode }
                Http.put('/users/change-email', bodyCheckCode, Http.headers)
                    .then(response => {
                        const responseData = response.data.response
                        if (!responseData.error) {
                            setShowValidateCode(false);
                            Message.showSuccess(responseData.message);
                            setLoading(false);
                            dispatch(setUserDataEmail(newEmail));

                            let token = localStorage.getItem("token");
                            Http.get(`/token-xchange?application_id=${2}&token=${token}`)
                                .then(response => {
                                    if (!response.data.response.error) {
                                        const token = response.data.data.access_token
                                        localStorage.setItem('token', token);
                                    }
                                }).catch(err => {

                                })
                        }
                    }).catch(err => {
                        setHasErrorCode(true);
                        setErrorMsgCode(err.response.data.response.message);
                        setLoading(false);
                    })
            }
        }

        function handleCancel() {
            setShowValidateCode(false);
            setHasErrorCode(false);
        }

        function renderForm() {
            if (loading) {
                return (
                    <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
                        <Loading width={50} height={50} />
                    </div>
                )
            } else {
                return (
                    <>
                        <p className={"modal-content-describe"}>Um código de verificação foi enviado para o seu e-mail, insira-o no campo abaixo para concluir.</p>
                        <p><MailIcon style={{ marginRight: 8 }} /> <span>{newEmail}</span></p>
                        <AccountInputValue name={"received_code"} labelText={"Insira o código aqui"} value={receivedCode}
                            onChange={(e) => { setReceivedCode(e.target.value); setHasErrorCode(false) }}
                            hasError={hasErrorCode} error={errorMsgCode} />
                    </>
                );
            }
        }

        return (
            <Modal
                visible={showValidateCode}
                title="Etapa de segurança"
                centered={true}
                onCancel={handleCancel}
                onOk={handleOk}
                footer={[
                    <a key="back" style={{ marginRight: 24 }} className={"account-link"}
                        onClick={handleCancel}>Cancelar
                    </a>,
                    <button key="submit" type="primary" className={"account-button account-button-primary"}
                        onClick={handleOk}>Confirmar e prosseguir
                    </button>
                ]}
            >
                {renderForm()}
            </Modal>
        );
    }

    const handleOnClick = () => {
        setNewEmail("");
        setReceivedCode("");
        setShowSolicitEmail(true);
    }

    if (props.editing) {
        return (
            <>
                <Col span={6}>
                    <AccountInputValue name={"main_email"} labelText={"E-mail principal"} label={"e-mail principal"} value={props.email} readOnly={true} />
                </Col>

                <Col span={14}>
                    <a style={{ marginLeft: 24 }} onClick={handleOnClick}
                        className={"account-link"}>Alterar email principal
                    </a>
                </Col>
                {solicitEmail()}
                {validateCode()}
            </>
        )
    } else {
        return (
            <Col span={20}>
                <span className={"account-card-data"}>{props.email}</span>
            </Col>
        )
    }
}
